import { MLPVersion, Theme } from '../../../';

/* eslint-disable no-unused-vars */
export enum InputValidations {
  VALID = 'valid',
  INVALID = 'invalid',
  DEFAULT = 'default',
  WARNING = 'warning'
}

export type DropdownOption = {
  id: string;
  title: string;
  userId?: string;
};

export type SearchTheme = Theme.ERROR | Theme.BLACK;
export type SearchProp = {
  label: string;
  labelInfo?: string;
  placeholder?: string;
  labelChoice?: string;
  initialSearchText?: string;
  dropdownOptions: DropdownOption[];
  onSearch: (text: string) => void;
  onClear?: () => void;
  onSelect: (e: DropdownOption) => void;
  disabled?: boolean;
  message?: string;
  status: InputValidations;
  theme?: SearchTheme;
  mlpVersion?: MLPVersion;
};
